import confetti from 'canvas-confetti'

function fire(particleRatio, opts) {
  const count = 200
  const defaults = {
    origin: { y: 0.7 },
    zIndex: '2000',
  }

  confetti(
    Object.assign({}, defaults, opts, {
      particleCount: Math.floor(count * particleRatio),
    })
  )
}

document
  .querySelector('.waiting-list-success-icon')
  .addEventListener('click', () => {
    function randomInRange(min, max) {
      return Math.random() * (max - min) + min
    }

    confetti({
      angle: randomInRange(55, 125),
      spread: randomInRange(50, 70),
      particleCount: randomInRange(50, 100),
      origin: { y: 0.6 },
      zIndex: '2000',
    })
  })

$('.waiting-list-form').on('ajax:complete', function (_e, xhr) {
  $('.waiting-list-form').hide()
  if (xhr?.responseJSON?.error) {
    $('.waiting-list-error .alert strong').html(xhr.responseJSON.error)
    $('.waiting-list-error').show()
  } else {
    $('.waiting-list-success').show()

    fire(0.25, {
      spread: 26,
      startVelocity: 55,
    })
    fire(0.2, {
      spread: 60,
    })
    fire(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8,
    })
    fire(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2,
    })
    fire(0.1, {
      spread: 120,
      startVelocity: 45,
    })
  }
})
